// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cb8d927e","453":"472407dd","455":"778af3aa","977":"f3639b72"}[chunkId] + ".chunk.js";
};